import 'bootstrap/dist/js/bootstrap.min.js';

// import './components/map';
import './components/menu';
import './components/cookies';
import './components/scrollUp';

import './components/slider';
import './components/sidebar';

import DataTable from 'datatables.net-dt';
import Chart from 'chart.js/auto';
import { getRelativePosition } from 'chart.js/helpers';

if($('#installation-chart').length) {
    $.getJSON(options.ajax_url + '?action=itlu_installations&installation_category=' + $('#installation-chart').data('category-id'), function (data) {
        const chart = new Chart($('#installation-chart'), {
            type: 'doughnut',
            data: {
                labels: data.map(row => row.label),
                datasets: [
                    {
                        label: 'Typ instalacji',
                        data: data.map(row => row.count)
                    }
                ]
            }
        });
    });
}


$(document).ready(function () {
    $('#installation-table').DataTable({
        language: {
            url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/pl.json'
        }
    });
});

var windowWidth = $(window).width();

$(document).ready(function () {
    $('.contact-email').each(function () {
        var email = $(this);
        email.text(email.data('contact-1') + '@' + email.data('contact-2'));
        email.attr('href', 'mailto: ' + email.data('contact-1') + '@' + email.data('contact-2'));
    });

    adjustElementHeight('#homepage-shortcuts .shortcuts-box-inner');

    $('#fb-sidebox-button').on('click', function () {
        $(this).parent().toggleClass('active');
    });


    if ($('#events-calendar').length > 0) {
        var calendarCategory = false;

        if ($('#events-calendar').data('category')) {
            calendarCategory = $('#events-calendar').data('category');
        }

        $("#events-calendar").eventCalendar({
            eventsjson: options.ajax_url + '?action=get_events&category=' + calendarCategory,
            locales: {
                locale: "pl",
                monthNames: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Pażdziernik", "Listopad", "Grudzień"],
                dayNames: ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'],
                dayNamesShort: ['Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob', 'Nie'],
                txt_noEvents: "Brak wydarzeń",
                txt_SpecificEvents_prev: "",
                txt_SpecificEvents_after: "wydarzenia:",
                txt_next: ">",
                txt_prev: "<",
                txt_NextEvents: "Nadchodzące wydarzenia:",
                txt_GoToEventUrl: "Czytaj więcej",
                txt_loading: 'Ładowanie...',

            }
        });
    }


    var bannersSlider = $('#banners-slider-carousel');

    if (bannersSlider.length > 0) {
        bannersSlider.owlCarousel({
            loop: true,
            margin: 10,
            dots: false,
            nav: false,
            autoplay: true,
            smartSpeed: 500,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 5
                }
            }
        });
    }

    $('#sidebar-menu .menu-item-has-children > a').click(function (event) {
        event.preventDefault();


        $(this).parent().toggleClass('active');
    });

    if ($('#newsletterModal').length > 0) {
        $('#newsletterModal').modal('show');
    }
});

$(window).scroll(function () {
    var header = $('header#header');
    var nav = $('#fixed-menu');

    if (windowWidth > 768) {
        if ($(window).scrollTop() > header.height() * 2) {
            nav.addClass('active');
        } else {
            nav.removeClass('active');
        }
    }
});

function adjustElementHeight(elementName) {
    var headingHeight = 0;
    $(elementName).each(function () {
        if (headingHeight < $(this).height()) {
            headingHeight = $(this).height();
        }
    })
    $(elementName).height(headingHeight);
}

$('#calculator-1 .calculator-input').on('change', function() {
    var result = 0;

    $('#calculator-1 .calculator-input').each(function() {
        if(result == 0) {
            result = $(this).val();
        }
        else {
            result *= $(this).val();
        }
    });

    if(result) {
        $('#calculator-1 .result-day').val(result);
        $('#calculator-1 .result-month').val(result * 31);
        $('#calculator-1 .result-year').val(result * 356);
    }
});

$('#calculator-2 .calculator-input').on('change', function() {
    var result = 0;

    $('#calculator-2 .calculator-input').each(function() {
        if(result == 0) {
            result = $(this).val();
        }
        else {
            result *= $(this).val();
        }
    });

    if(result) {
        $('#calculator-2 .result-day').val(result);
        $('#calculator-2 .result-month').val(result * 31);
        $('#calculator-2 .result-year').val(result * 356);
    }
});

$('#calculator-3 .calculator-input').on('change', function() {
    var result = 0;

    $('#calculator-3 .calculator-input').each(function() {
        if(result == 0) {
            result = $(this).val();
        }
        else {
            result *= $(this).val();
        }
    });

    if(result) {
        $('#calculator-3 .result-day').val(result);
        $('#calculator-3 .result-month').val(result * 31);
        $('#calculator-3 .result-year').val(result * 356);
    }
});

$('#calculator-4 .calculator-input').on('change', function() {
    var result = 0;

    $('#calculator-4 .calculator-input').each(function() {
        if(result == 0) {
            result = $(this).val();
        }
        else {
            result *= $(this).val();
        }
    });

    if(result) {
        $('#calculator-4 .result-day').val(result);
        $('#calculator-4 .result-month').val(result * 31);
        $('#calculator-4 .result-year').val(result * 356);
    }
});

$('#calculator-5 .calculator-device').on('change', function() {
    $(this).parent().parent().children('.calculator-device-power-wrapper').children('.calculator-device-power').val($(this).val()).trigger('change');
});

$('#calculator-5 .calculator-input').on('change', function() {
    var result = 0;
    var price = $('.calculator-price').val();

    $('#calculator-5 .calculator-row').each(function() {
        var row_result = 0;
 
        $(this).find('.calculator-input').each(function() {
            console.log($(this).val());
            if(row_result == 0) {
                row_result = $(this).val();
            }
            else {
                row_result *= $(this).val();
            }
        });

        if(row_result) {
            result += parseInt(row_result);
        }
    });

    result = result / 1000;

    if(result && price) {
        $('#calculator-5 .result-day').val(result);
        $('#calculator-5 .result-price-day').val(result * price);
        $('#calculator-5 .result-month').val(result * 31);
        $('#calculator-5 .result-price-month').val(result * 31 * price);
        $('#calculator-5 .result-year').val(result * 356);
        $('#calculator-5 .result-price-year').val(result * 356 * price);
    }
});